import React from 'react';

export default function EventDetailsTab({ eventDetails, setEventDetails }) {
  return (
    <div className="space-y-6">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Event Name</label>
        <input
          type="text"
          value={eventDetails.name}
          onChange={e => setEventDetails({ ...eventDetails, name: e.target.value })}
          className="w-full px-4 py-2 border rounded-lg text-gray-900 focus:ring-2 focus:ring-green-500"
          data-testid="event-name-input"
        />
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Description</label>
        <textarea
          value={eventDetails.description}
          onChange={e => setEventDetails({ ...eventDetails, description: e.target.value })}
          className="w-full px-4 py-2 border rounded-lg text-gray-900 focus:ring-2 focus:ring-green-500"
          rows={4}
          data-testid="event-description-input"
        />
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Start Date</label>
          <input
            type="date"
            value={eventDetails.start_date}
            onChange={e => setEventDetails({ ...eventDetails, start_date: e.target.value })}
            className="w-full px-4 py-2 border rounded-lg text-gray-900 focus:ring-2 focus:ring-green-500"
            data-testid="event-start-date"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">End Date</label>
          <input
            type="date"
            value={eventDetails.end_date}
            onChange={e => setEventDetails({ ...eventDetails, end_date: e.target.value })}
            className="w-full px-4 py-2 border rounded-lg text-gray-900 focus:ring-2 focus:ring-green-500"
            data-testid="event-end-date"
          />
        </div>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Registration Deadline</label>
          <input
            type="date"
            value={eventDetails.registration_deadline}
            onChange={e => setEventDetails({ ...eventDetails, registration_deadline: e.target.value })}
            className="w-full px-4 py-2 border rounded-lg text-gray-900 focus:ring-2 focus:ring-green-500"
            data-testid="event-deadline"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Max Registrations</label>
          <input
            type="number"
            value={eventDetails.max_registrations}
            onChange={e => setEventDetails({ ...eventDetails, max_registrations: parseInt(e.target.value) || 0 })}
            className="w-full px-4 py-2 border rounded-lg text-gray-900 focus:ring-2 focus:ring-green-500"
            min={0}
            data-testid="event-max-registrations"
          />
        </div>
      </div>
    </div>
  );
}
